'use client'

import type { CardVideoType } from '@/components/atoms/CardVideo'
import { CardVideo } from '@/components/atoms/CardVideo'
import type { FC } from 'react'
import { Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { IconCircle } from '../atoms/IconCircle'
import { bulletActiveClass, bulletClass } from '../molecules/CarouselCardImages'
import ContentBlockWrapper from '../molecules/ContentBlockWrapper'

// Import Swiper styles
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

export type CarouselVideoCardsBlockProps = {
	cards: CardVideoType[]
}

export const CarouselVideoCardsBlock: FC<CarouselVideoCardsBlockProps> = ({ cards }) => {
	return (
		<ContentBlockWrapper className="overflow-hidden" blockTypes={['component']}>
			<div className="relative col-span-full">
				<Swiper
					modules={[Navigation, Pagination]}
					spaceBetween={16}
					slidesPerView={1}
					navigation={{
						prevEl: '.swiper-button-prev-custom',
						nextEl: '.swiper-button-next-custom',
					}}
					pagination={{
						clickable: true,
						el: '.swiper-pagination-custom',
						bulletClass: bulletClass,
						bulletActiveClass: bulletActiveClass,
					}}
					breakpoints={{
						1024: {
							slidesPerView: 2,
							spaceBetween: 16,
						},
						1280: {
							slidesPerView: 3,
							spaceBetween: 24,
						},
					}}
					watchSlidesProgress={true}
					className="!overflow-visible"
				>
					{cards.map((card) => (
						<SwiperSlide key={card.id}>
							<CardVideo card={card} />
						</SwiperSlide>
					))}

					{/* Custom Navigation Buttons */}
					<div className="pointer-events-none absolute top-0 left-0 hidden aspect-card-video tablet-l:block tablet-l:w-1/2 desktop:w-1/3">
						<button
							className="swiper-button-prev-custom group pointer-events-auto absolute top-1/2 left-0 z-10 flex translate-x-8 -translate-y-[calc(50%+14px)] cursor-pointer items-center justify-center rounded-full disabled:pointer-events-none disabled:opacity-0"
							aria-label="Previous"
						>
							<IconCircle icon={['fal', 'chevron-left']} size="sm" theme="blue" />
						</button>
					</div>

					<div className="pointer-events-none absolute top-0 right-0 hidden aspect-card-video tablet-l:block tablet-l:w-1/2 desktop:w-1/3">
						<button
							className="swiper-button-next-custom group pointer-events-auto absolute top-1/2 right-0 z-10 flex -translate-x-8 -translate-y-[calc(50%+14px)] cursor-pointer items-center justify-center rounded-full disabled:pointer-events-none disabled:opacity-0"
							aria-label="Next"
						>
							<IconCircle icon={['fal', 'chevron-right']} size="sm" theme="blue" />
						</button>
					</div>
				</Swiper>

				{/* Custom Pagination */}
				<div className="swiper-pagination-custom mt-xl flex justify-center gap-2"></div>
			</div>
		</ContentBlockWrapper>
	)
}

export default CarouselVideoCardsBlock
